import { extractLastNameComponent } from '@spotify/confidence-core-react';

export const getIssueChatName = (issueName: string): string | undefined => {
  const issueId = extractLastNameComponent(issueName);
  return issueId ? `chats/issue-${issueId}` : undefined;
};
